module.exports = __webpack_public_path__ + "static/auto_import_737x562-a72fe477e77223674416f301807d9af6.png";